<template>
  <router-view />
</template>

<script>
export default {
  name: 'FinanceIndex'
}
</script>
